/* eslint-disable no-shadow */
import { withStyles } from "@material-ui/core";
import React from "react";
import styles from "./styles";
import { IMAGE_BASE_URL } from "../../../constants/ui";

import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";

function Project(props) {
  const { classes, sliders } = props;

  const handleOnDragStart = e => e.preventDefault();

  const renderSlider = () => {
    let result = null;

    if (sliders && sliders.length > 0) {
      result = sliders.map(item => (
        <img
          key={`slider-${item.id}`}
          onDragStart={handleOnDragStart}
          src={`${IMAGE_BASE_URL}/${item.picture}`}
          alt={item.name}
        />
      ));
    }

    return result;
  };

  return (
    <div className={classes.slider}>
      <AliceCarousel
        buttonsDisabled
        infinite
        autoPlay
        autoPlayInterval={5000}
        stopAutoPlayOnHover
        mouseTrackingEnabled
      >
        {renderSlider()}
      </AliceCarousel>
    </div>
  );
}

export default withStyles(styles)(Project);
